const MULTIFORMS = {
    listMultiForms: "Multiformes",
    newMultiForms: "Novo",
  
    activity: "Exercício",
    group: "Conjunto",
    totalQestion: "Total de perguntas:",
    company: "Companhia",
    quantity: "Quantidade",
    state: "Doença",
    actions: "Ações",
  
    accept: "Aceitar",
    cancel: "Cancelar",
  
    NOTIFYCATIONS: {
      emptyMultiforms: `Não há multiforms registrados`,
      titleGetMultiForms: "Lista de formulários",
    },
  
    CONFIRM: {
      tittleDeleteMultiForm: "Remover MultiForm: {activity}",
      textDeleteMultiForm: "Esta opção não pode ser desfeita, tem certeza?",
      ErrorDeleteMultiFormTittle: "Excluir MultiFormulário",
      ErrorDeleteMultiFormText: "Ocorreu um erro ao excluir o MultiForm"
    },
  
    information: "EM FORMAÇÃO",
    assiciateForms: "Formulários associados:",
  
    mulstiStandar: "Formulários padrão",
    placeHolderSearch: "Procurar...",
    FormsAdd: "Formulários adicionados:",
    save: "Salvar",
    NameToMultiForms: "Nome para o multiforme",
  
    ALERTS: {
      tittleListForms: "Lista de formulários",
      textAddFormToMulti: "Adicionar formulários à lista",
      nameToForm: "Nome do formulario",
      EnterNameToForm: "Digite o nome do formulário",
      titleSelectedGroup: "Seleção de grupo",
      selectedGroup: "Selecione o grupo"
    },
  
    success: "Criada!",
    successMultiForm: "MultiForm criado.",
  
    error: "Erro!",
    errorMultiForm: "Ocorreu um erro ao criar o multiform",
  
  };
  
  export default { MULTIFORMS };